import { createContext } from "react";

const sidebarContext = createContext([{}, function () {}]);

export default sidebarContext;
